// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalMenuContextsMobile__outer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 9999999999;
}

.ModalMenuContextsMobileGeo__outer {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #2A3034;
  z-index: 9999999999;
}

.ModalMenuContextsMobile__outer svg {
  color: #8E9193;
}

.ModalMenuContextsMobile__header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.ModalMenuContextsMobile__arrow-right {
  margin-right: 8px;
}

.ModalMenuContextsMobile__word {
  margin-right: 17px;
}

.ModalMenuContextsMobile__category {
  margin-right: auto;
}

.ModalMenuContextsMobile__category div {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #151514;
  padding-top: 2px;
}

.ModalMenuContextsMobile__list-links {
  position: absolute;
  right: 0;
  top: 60px;
  padding-right: 10px;
  color: #8E9193;
  margin-bottom: 20px;
}

.ModalMenuContextsMobile__list-links div {
  margin: 8px 0;
}

.ModalMenuContextsMobile__list-links a {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
}

.ModalMenuContextsMobile__item--active {
  color: #151514;
}

.ModalMenuContextsMobile__list {
  position: absolute;
  right: 0;
  bottom: 60px;
  left: 0;
  padding-left: 10px;
  color: #8E9193;
}

.ModalMenuContextsMobile__list div {
  margin: 8px 0;
}

.ModalMenuContextsMobile__list a {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
}

.ModalMenuContextsMobile__item--active {
  color: #151514;
}
`, "",{"version":3,"sources":["webpack://./src/shared/navbars/ModalMenuContextsMobile.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ModalMenuContextsMobile__outer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  z-index: 9999999999;\n}\n\n.ModalMenuContextsMobileGeo__outer {\n  position: fixed;\n  top: 48px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #2A3034;\n  z-index: 9999999999;\n}\n\n.ModalMenuContextsMobile__outer svg {\n  color: #8E9193;\n}\n\n.ModalMenuContextsMobile__header {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.ModalMenuContextsMobile__arrow-right {\n  margin-right: 8px;\n}\n\n.ModalMenuContextsMobile__word {\n  margin-right: 17px;\n}\n\n.ModalMenuContextsMobile__category {\n  margin-right: auto;\n}\n\n.ModalMenuContextsMobile__category div {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 21px;\n  color: #151514;\n  padding-top: 2px;\n}\n\n.ModalMenuContextsMobile__list-links {\n  position: absolute;\n  right: 0;\n  top: 60px;\n  padding-right: 10px;\n  color: #8E9193;\n  margin-bottom: 20px;\n}\n\n.ModalMenuContextsMobile__list-links div {\n  margin: 8px 0;\n}\n\n.ModalMenuContextsMobile__list-links a {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n}\n\n.ModalMenuContextsMobile__item--active {\n  color: #151514;\n}\n\n.ModalMenuContextsMobile__list {\n  position: absolute;\n  right: 0;\n  bottom: 60px;\n  left: 0;\n  padding-left: 10px;\n  color: #8E9193;\n}\n\n.ModalMenuContextsMobile__list div {\n  margin: 8px 0;\n}\n\n.ModalMenuContextsMobile__list a {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n}\n\n.ModalMenuContextsMobile__item--active {\n  color: #151514;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalMenuContextsMobile__outer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 9999999999;
}

.ModalMenuContextsMobileGeo__outer {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #2A3034;
  z-index: 9999999999;
}

.ModalMenuContextsMobile__outer svg {
  color: #8E9193;
}

.ModalMenuContextsMobile__header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.ModalMenuContextsMobile__arrow-right {
  margin-right: 8px;
}

.ModalMenuContextsMobile__word {
  margin-right: 17px;
}

.ModalMenuContextsMobile__category {
  margin-right: auto;
}

.ModalMenuContextsMobile__category div {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #151514;
  padding-top: 2px;
}

.ModalMenuContextsMobile__list-links {
  position: absolute;
  right: 0;
  top: 60px;
  padding-right: 10px;
  color: #8E9193;
  margin-bottom: 20px;
}

.ModalMenuContextsMobile__list-links div {
  margin: 8px 0;
}

.ModalMenuContextsMobile__list-links a {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
}

.ModalMenuContextsMobile__item--active {
  color: #151514;
}

.ModalMenuContextsMobile__list {
  position: absolute;
  right: 0;
  bottom: 60px;
  left: 0;
  padding-left: 10px;
  color: #8E9193;
}

.ModalMenuContextsMobile__list div {
  margin: 8px 0;
}

.ModalMenuContextsMobile__list a {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
}

.ModalMenuContextsMobile__item--active {
  color: #151514;
}
`, "",{"version":3,"sources":["webpack://./src/shared/navbars/ModalMenuContextsMobile.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ModalMenuContextsMobile__outer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  z-index: 9999999999;\n}\n\n.ModalMenuContextsMobileGeo__outer {\n  position: fixed;\n  top: 48px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #2A3034;\n  z-index: 9999999999;\n}\n\n.ModalMenuContextsMobile__outer svg {\n  color: #8E9193;\n}\n\n.ModalMenuContextsMobile__header {\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n}\n\n.ModalMenuContextsMobile__arrow-right {\n  margin-right: 8px;\n}\n\n.ModalMenuContextsMobile__word {\n  margin-right: 17px;\n}\n\n.ModalMenuContextsMobile__category {\n  margin-right: auto;\n}\n\n.ModalMenuContextsMobile__category div {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 21px;\n  color: #151514;\n  padding-top: 2px;\n}\n\n.ModalMenuContextsMobile__list-links {\n  position: absolute;\n  right: 0;\n  top: 60px;\n  padding-right: 10px;\n  color: #8E9193;\n  margin-bottom: 20px;\n}\n\n.ModalMenuContextsMobile__list-links div {\n  margin: 8px 0;\n}\n\n.ModalMenuContextsMobile__list-links a {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n}\n\n.ModalMenuContextsMobile__item--active {\n  color: #151514;\n}\n\n.ModalMenuContextsMobile__list {\n  position: absolute;\n  right: 0;\n  bottom: 60px;\n  left: 0;\n  padding-left: 10px;\n  color: #8E9193;\n}\n\n.ModalMenuContextsMobile__list div {\n  margin: 8px 0;\n}\n\n.ModalMenuContextsMobile__list a {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n}\n\n.ModalMenuContextsMobile__item--active {\n  color: #151514;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
